import React, { ComponentType } from 'react'
import Loader from 'components/common/loader'
import { useDispatch, useSelector } from 'react-redux'
import { useNotificationPermission } from 'core/services/notifications/useNotificationPermission'
import { ApplicationState } from 'core/store/reducers'
import AlertDialog from '../../components/dialogs/alertDialog'
import { useTranslation } from 'react-i18next'
import { getToken } from 'firebase/messaging'
import { setCouldAskForNotification, setFirebaseMessagingToken } from '../../core/store/app/actions'

const withNotifications = (ComposedComponent: ComponentType<any>, loader: React.ReactNode = <Loader />) => {
    const WithNotifications: React.FC<any> = ({ ...props }) => {
        const dispatch = useDispatch()
        const { t } = useTranslation()
        const { checkNotificationPermission } = useNotificationPermission()
        const { firebaseMessaging, firebaseMessagingToken, couldAskForNotification } = useSelector(
            ({ app }: ApplicationState) => ({
                firebaseMessaging: app.firebaseMessaging,
                firebaseMessagingToken: app.firebaseMessagingToken,
                couldAskForNotification: app.couldAskForNotification,
            }),
        )

        const requestPermission = async () => {
            if (!firebaseMessaging) return
            try {
                const token = await getToken(firebaseMessaging, { vapidKey: process.env.REACT_APP_FCM_KEY })
                if (token) {
                    dispatch(setFirebaseMessagingToken(token))
                }
            } catch (error) {
                console.error('Error requesting permission:', error)
            }
        }

        const handClose = async () => {
            dispatch(setCouldAskForNotification(false))
        }
        return (
            <>
                <ComposedComponent {...props} />
                {firebaseMessaging &&
                    couldAskForNotification &&
                    !firebaseMessagingToken &&
                    checkNotificationPermission() === 'default' && (
                        <AlertDialog
                            title={t('dialog.notification.title')}
                            content={t('dialog.notification.content')}
                            buttons={[
                                {
                                    variant: 'outlined',
                                    children: t('actions.close'),
                                    onClick: handClose,
                                },
                                {
                                    variant: 'contained',
                                    color: 'primary',
                                    children: t('actions.allow'),
                                    onClick: requestPermission,
                                },
                            ]}
                            onClose={handClose}
                        />
                    )}
            </>
        )
    }
    return WithNotifications
}

export default withNotifications
